// @ts-nocheck
import { field } from '../claim.fields';

export function validateFields(array) {
	let hasError = false;

	field.fields.forEach((mainFields: any) => {
		if (!mainFields.value && mainFields.required && array.includes(mainFields.entityKey)) {
			hasError = true;
			if (mainFields === 'selectNewPhase') mainFields.error = ['Selecione uma fase'];
			else mainFields.error = ['Campo obrigatório'];
		} else {
			if (mainFields.type === 'ADDITIONAL_VALUES') {
				mainFields.fields.forEach((groups) => {
					if (groups.enabled) {
						groups.fields.forEach((items) => {
							items.forEach((item) => {
								if (!item.value && item.required && array.includes(item.entityKey)) {
									hasError = true;
									groups.error = ['Campo obrigatório'];
									item.error = ['Campo obrigatório'];
								}
							});
						});
					}
				});
			}
		}
	});

	return hasError;
}
